import React from 'react';
import './ShopFeaturedProduct.scss';
import Card from '../UI/Card/Card';

/**
 *
 * @param {object} image
 * @param {object} product
 * @param {string} starsAssetUrl
 * @param {boolean} showRating
 * @param {boolean} showPrice
 * @param {string} cardType
 * @param {boolean} isLinked
 * @param {boolean} alignment - toggle left/right alignment
 * @param {string} cardBgColor
 * @param {boolean} extraBottomPadding
 * @param {boolean} disabled
 * @param {boolean} enablePreorder
 * @returns {JSX.Element}
 * @constructor
 */
const ShopFeaturedProduct = ({
  image,
  product,
  starsAssetUrl,
  showRating,
  showPrice,
  cardType,
  isLinked = true,
  alignment,
  cardBgColor,
  extraBottomPadding = false,
  disabled,
  enablePreorder = false,
}) =>
  !disabled ? (
    <div
      className={`c-shop-featured-product background-color-gray ${
        extraBottomPadding ? 'bottom-padding' : ''
      }`}
    >
      <div className={`c-shop-featured-product__inner ${alignment ? 'align-left' : 'align-right'}`}>
        <div className="c-shop-featured-product__image-container">
          <img src={image?.url} alt={image?.alt} />
        </div>
        <div
          className={`c-shop-featured-product__card-container ${alignment ? '' : 'margin-right'}`}
        >
          <Card
            type={cardType}
            product={product}
            starsAssetUrl={starsAssetUrl}
            showRating={showRating}
            showPrice={showPrice}
            isLinked={isLinked}
            backgroundColor={cardBgColor}
            enablePreorder={enablePreorder}
          />
        </div>
      </div>
    </div>
  ) : (
    <div className="c-shop-featured-product__spacer background-color-gray"></div>
  );

export default ShopFeaturedProduct;
